<div id="layout" class="f_col container layout_sm">
    <app-view-title bgImage="assets-countries/header_background.png">{{'user.choose_activity.DYN.'+ type | translate}}</app-view-title>
    <form id="form" [formGroup]="form" class="mb_20 mt_20">
      <app-date-range (onChange)="activity.onDateRangeChanged($event)"></app-date-range>
    </form>
    <div class="scroll_wrapper" [class.scroll_disabled]="isWeb" (scroll)="!isWeb && onScroll($event)">
      <div class="mt_20">
        <app-activity-list [userInfo]="this.api.userInfo" [inputArray]="activity?.filterActivities ?? activity.activities" *ngIf="activity.activities?.length > 0"></app-activity-list>
      </div>
    </div>
    <app-back-btn (click)="nav.to('more')"></app-back-btn>
</div>
